import { renderReact } from "hypernova-react";
import CookieBannerVariation from "web/react/components/cookie-banner/cookie-banner-variation";
import CustomerCaptureOverlay from "web/react/components/customer-capture-overlay/customer-capture-overlay";
import Example from "web/react/components/example/example";
import ExpressCheckoutProductPage from "web/react/components/express-checkout-product-page/express-checkout-product-page";
import FeedControls from "web/react/components/feed-controls/feed-controls";
import FeedGenderSwitch from "web/react/components/feed-gender-switch/feed-gender-switch";
import FeedSwitchTabOverlay from "web/react/components/feed-switch-tab-overlay/feed-switch-tab-overlay";
import FeedsSeoContent from "web/react/components/feeds-seo-content/feeds-seo-content";
import FeedsShowMoreContainer from "web/react/components/feeds-show-more-container/feeds-show-more-container";
import FilterContainer from "web/react/components/filter-container/filter-container";
import FollowStickyBanner from "web/react/components/follow-sticky-banner/follow-sticky-banner";
import HomepageOverlay from "web/react/components/homepage-overlay/homepage-overlay";
import HomepageStoreRail from "web/react/components/homepage-store-rail/homepage-store-rail";
import MainNavigation from "web/react/components/main-navigation/main-navigation";
import MainNavigationToggleMobile from "web/react/components/main-navigation/main-navigation-toggle-mobile/main-navigation-toggle-mobile";
import ProductArea from "web/react/components/product-area/product-area";
import RecentlyViewedEmailCapture from "web/react/components/recently-viewed-email-capture/recently-viewed-email-capture";
import RelatedProductsRails from "web/react/components/related-products-rails/related-products-rails";
import RelatedSearchesRail from "web/react/components/related-searches-rail/related-searches-rail";
import RelatedDesignersRail from "web/react/components/related-designers-rail/related-designers-rail";
import RetailerPromotionHub from "web/react/components/retailer-promotion-hub/retailer-promotion-hub";
import SearchButton from "web/react/components/search-button/search-button";
import UnsubscribeOverlay from "web/react/components/unsubscribe-overlay/unsubscribe-overlay";
import ProductPage from "web/react/pages/product/in-stock/in-stock";
import OOSProductPage from "web/react/pages/product/out-of-stock/out-of-stock";
import withRedux from "web/react/redux-provider";

export const renderableComponents: { [name: string]: React.ComponentType<any> } = {
    CookieBannerVariation,
    CustomerCaptureOverlay,
    Example,
    ExpressCheckoutProductPage,
    FeedControls: withRedux(FeedControls),
    FeedGenderSwitch: withRedux(FeedGenderSwitch),
    FeedSwitchTabOverlay,
    FeedsSeoContent,
    FeedsShowMoreContainer: withRedux(FeedsShowMoreContainer),
    FilterContainer: withRedux(FilterContainer),
    FollowStickyBanner,
    HomepageOverlay,
    HomepageStoreRail,
    MainNavigation,
    MainNavigationToggleMobile,
    OOSProductPage,
    ProductArea: withRedux(ProductArea as any), // TODO: ProductArea's proptypes are broken
    ProductPage,
    RecentlyViewedEmailCapture,
    RelatedProductsRails,
    RelatedDesignersRail,
    RelatedSearchesRail,
    RetailerPromotionHub,
    SearchButton,
    UnsubscribeOverlay,
};

export function initialiseReact(): void {
    for (let [name, component] of Object.entries(renderableComponents)) {
        renderReact(name, component);
    }
}
